export const GO_TO_FEEDBACK_OPTIONS = [
  {
    value: "a",
    title: "I have my plan built for me",
    description: "NutriCoach creates the full plan based on my preferences.",
  },
  {
    value: "b",
    title: "I help build my plan",
    description:
      "Like the one you've just completed — I choose some meals and snacks from NutriCoach's selection, and it fills in the rest with calories & macros worked out for me.",
  },
  {
    value: "c",
    title: "I build my own plan",
    description:
      "I choose all my meals and snacks from NutriCoach's selection, with calories & macros worked out for me.",
  },
  {
    value: "d",
    title: "I'm not sure",
    description: "I'd need more guidance before deciding.",
  },
] as const;
